var config = {
    db:{
        uri:"mongodb://drmis:DevAdmin429@3.144.236.191:27017/drmis_backup"
    },
    remote:{
        //uri:"http://18.223.108.211:3005",
        uri:process.env.VUE_APP_ENGINE_URL,
    }
   };


  module.exports = config;
